// extracted by mini-css-extract-plugin
export default {"container":"KeyNavigationHandlerContainer_container__2AxtN"};